import { render, staticRenderFns } from "./BaseDeleteDialog.vue?vue&type=template&id=7a21ec3a&scoped=true"
import script from "./BaseDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BaseDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21ec3a",
  null
  
)

export default component.exports